import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../../services/shared.service';
declare var Swiper: any;

@Component({
  selector: 'app-my-carousel-swiper',
  templateUrl: './my-carousel-swiper.component.html',
  styleUrls: ['./my-carousel-swiper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyCarouselSwiperComponent implements AfterViewInit, OnChanges {

  @Input() config: any = null;
  @Input() navigation: boolean = true;
  @Input() slide: any = [];
  @Input() centerSlider: boolean = false;
  @Input() cssClass: any = null;

  @ViewChild('swiperContainer') swiperContainer: ElementRef;
  private needsWidthAdjustment: boolean = false;
  private swiper: any;
  @Output() onSwiper = new EventEmitter<any>();
  @Output() onSlideChange = new EventEmitter<any>();


  constructor(private sharedService: SharedService) { }

  ngAfterViewInit(): void {
    if (this.sharedService.isBrowser()) {
      this.updateSwiper();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['slide'] && this.slide?.length > 0) {
      if (changes['slide']?.previousValue && (changes['slide'].currentValue.length !== changes['slide'].previousValue.length)) {
        this.updateSwiper();
      }
      this.scheduleWidthAdjustment();
    }
    if (changes['config'] && !changes['config'].firstChange) {
      this.updateSwiper();
    }
  }

  private initSwiper(): void {
    if (this.sharedService.isBrowser()) {
      this.swiper = new Swiper(this.swiperContainer?.nativeElement, {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: '.my-swiper-pagination',
          clickable: true,
        },
        navigation: this.navigation ? {
          nextEl: '.my-swiper-next',
          prevEl: '.my-swiper-prev',
        } : {},
        ...this.config,
      });

      this.onSwiper.emit(this.swiper);

      this.swiper.on('slideChange', (e) => {
        this.onSlideChange.emit(e);
      })

      // Ensure navigation is updated after initialization
      this.swiper?.navigation?.update();
      this.swiper?.swiperRef?.autoplay?.start();


      // Schedule a width adjustment after initialization
      this.scheduleWidthAdjustment();
    }
  }

  private scheduleWidthAdjustment(): void {
    // Use this flag to ensure width adjustment happens after view changes
    if (this.centerSlider) {
      this.needsWidthAdjustment = true;
    }

    if (this.needsWidthAdjustment) {
      this.adjustContainerWidth();
      this.needsWidthAdjustment = false;
    }
  }

  private adjustContainerWidth(): void {
    const swiperWrapper = this.swiperContainer?.nativeElement?.querySelector('.swiper-wrapper');
    if (swiperWrapper) {
      const children = swiperWrapper.children;
      var fullWidth = 0;
      for (let i = 0; i < this.slide.length; i++) {
        const childElement = children[i];
        const childWidth = childElement?.offsetWidth + this.config.spaceBetween;
        fullWidth += childWidth;
      }
      if (fullWidth < this.swiperContainer.nativeElement.offsetWidth) {
        this.swiperContainer.nativeElement.style.width = fullWidth + 'px';
      } else {
        this.swiperContainer.nativeElement.style.width = ''; // Reset width if not needed
      }
      this.swiper?.navigation?.update();
    }

    // Ensure navigation is updated after width adjustment
  }

  private updateSwiper(): void {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
    this.initSwiper();
  }
}
